import type { SvgIconProps } from '@mui/material/SvgIcon';
import { HelpOutline } from '@mui/icons-material';
import { iconMap } from './dynamic-mui-icon.constants';
import type { IconName } from './dynamic-mui-icon.constants';

const DynamicMuiIcon: React.FC<{ iconName: IconName; size?: number } & SvgIconProps> = ({
  iconName,
  size = 48,
  ...props
}) => {
  const Icon = iconMap[iconName] ?? HelpOutline;
  return <Icon sx={{ fontSize: size }} {...props} />;
};

export default DynamicMuiIcon;
